"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _global = require("./global");

/** @jsx jsx */
var Core = function Core() {
  return (0, _core.jsx)(_core.Global, {
    styles: _global.styles
  });
};

var _default = Core;
exports.default = _default;